import { render, staticRenderFns } from "./productVariationsPopover.vue?vue&type=template&id=e4009474&"
import script from "./productVariationsPopover.vue?vue&type=script&lang=js&"
export * from "./productVariationsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports